import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fill-space',
  template: '<span class="fill-space"></span>',
  styles: ['']
})
export class FillSpaceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
